const filterFields = (searchTerm, json, rootKey = '') => (
  Object
    .entries(json)
    .reduce((filteredKeys, pair) => {
      const key = rootKey ? `${rootKey}.${pair[0]}` : pair[0];
      const filteredChildren = (typeof pair[1] === 'object'
        ? filterFields(searchTerm, pair[1], key)
        : []
      );

      if (filteredChildren.length || pair[0].includes(searchTerm)) filteredChildren.push(key);

      return filteredKeys.concat(filteredChildren);
    }, [])
);

export default filterFields;
